import { PricingTierService } from 'src/app/services/pricing-tier.service';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { ModalController, LoadingController, AlertController, Platform } from '@ionic/angular/lazy';
import { AuthService } from 'src/app/services/auth.service';
import { APIService } from 'src/app/services/api.service';
import { Router } from '@angular/router';
import { CartService } from 'src/app/services/cart.service';
import { CountryService } from 'src/app/services/country.service';
import { ObserverService } from 'src/app/services/observer.service';
import { OrganisationService } from 'src/app/services/organisation.service';
import { PermissionService } from 'src/app/services/permission.service';
import { CountryPickerPage } from 'src/app/modals/country-picker/country-picker.page';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-organisation-edit',
    templateUrl: './organisation-edit.page.html',
    styleUrls: ['./organisation-edit.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class OrganisationEditPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    params = {};
    modal_css_class = '';
    @Input() organisation_id = null;
    organisation = null;
    pricing_tiers = null;
    countries = null;

    mailing_address_country = null;
    mailing_address_subdivisions = null;
    mailing_address_requires_subdivision = false;
    mailing_address_subdivision_label = "State / Province / Region / County";
    mailing_address_subdivision_label_changed = false;
    mailing_address_requires_postal_code = false;
    mailing_address_postal_code_label = "Postcode";

    billing_address_country = null;
    billing_address_subdivisions = null;
    billing_address_requires_subdivision = false;
    billing_address_subdivision_label = "State / Province / Region / County";
    billing_address_subdivision_label_changed = false;
    billing_address_requires_postal_code = false;
    billing_address_postal_code_label = "Postcode";

    // modal flags
    country_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public loadingController: LoadingController,
        public alertController: AlertController,
        private platform: Platform,
        private authService: AuthService,
        private apiService: APIService,
        private cartService: CartService,
        private router: Router,
        private countryService: CountryService,
        private observerService: ObserverService,
        private organisationService: OrganisationService,
        private pricingTierService: PricingTierService,
        public permissionService: PermissionService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.modal_css_class = 'fullscreen';
        }

        this.countryService.getCountries().then((countries) => {
            if(countries) {
                this.countries = countries;
            }
        })
        .catch(() => { });

        if(this.organisation_id) {


            this.loadData().then(() => {

                this.params['title'] = this.organisation.title;
                this.params['allow_on_account_payment_method'] = this.organisation.allow_on_account_payment_method;
                this.params['pricing_tier_id'] = this.organisation.pricing_tier.id;
                this.params['internal_note'] = "";
                this.params["mailing_address_premises"] = "";
                this.params["mailing_address_line_1"] = "";
                this.params["mailing_address_line_2"] = "";
                this.params["mailing_address_locality"] = "";
                this.params["mailing_address_subdivision"] = "";
                this.params["mailing_address_postal_code"] = "";
                this.params["mailing_address_country_id"] = "";
                this.params["billing_address_premises"] = "";
                this.params["billing_address_line_1"] = "";
                this.params["billing_address_line_2"] = "";
                this.params["billing_address_locality"] = "";
                this.params["billing_address_subdivision"] = "";
                this.params["billing_address_postal_code"] = "";
                this.params["billing_address_country_id"] = "";

                if(this.organisation.internal_note) {
                    this.params['internal_note'] = this.organisation.internal_note;
                }

                if(this.organisation.mailing_address) {
                    if(this.organisation.mailing_address.premises) {
                        this.params["mailing_address_premises"] = this.organisation.mailing_address.premises;
                    }
                    if(this.organisation.mailing_address.line_1) {
                        this.params["mailing_address_line_1"] = this.organisation.mailing_address.line_1;
                    }
                    if(this.organisation.mailing_address.line_2) {
                        this.params["mailing_address_line_2"] = this.organisation.mailing_address.line_2;
                    }
                    if(this.organisation.mailing_address.locality) {
                        this.params["mailing_address_locality"] = this.organisation.mailing_address.locality;
                    }
                    if(this.organisation.mailing_address.subdivision) {
                        this.params["mailing_address_subdivision"] = this.organisation.mailing_address.subdivision;
                    }
                    if(this.organisation.mailing_address.postal_code) {
                        this.params["mailing_address_postal_code"] = this.organisation.mailing_address.postal_code;
                    }
                    if(this.organisation.mailing_address.country) {

                        this.params["mailing_address_country_id"] = this.organisation.mailing_address.country.id;

                        this.loadMailingAddressCountry(this.organisation.mailing_address.country.id).then(() => {
                            this.mailingAddressCountryChanged();
                        })
                        .catch(() => { });

                    }
                }

                if(this.organisation.billing_address) {
                    if(this.organisation.billing_address.premises) {
                        this.params["billing_address_premises"] = this.organisation.billing_address.premises;
                    }
                    if(this.organisation.billing_address.line_1) {
                        this.params["billing_address_line_1"] = this.organisation.billing_address.line_1;
                    }
                    if(this.organisation.billing_address.line_2) {
                        this.params["billing_address_line_2"] = this.organisation.billing_address.line_2;
                    }
                    if(this.organisation.billing_address.locality) {
                        this.params["billing_address_locality"] = this.organisation.billing_address.locality;
                    }
                    if(this.organisation.billing_address.subdivision) {
                        this.params["billing_address_subdivision"] = this.organisation.billing_address.subdivision;
                    }
                    if(this.organisation.billing_address.postal_code) {
                        this.params["billing_address_postal_code"] = this.organisation.billing_address.postal_code;
                    }
                    if(this.organisation.billing_address.country) {

                        this.params["billing_address_country_id"] = this.organisation.billing_address.country.id;

                        this.loadBillingAddressCountry(this.organisation.billing_address.country.id).then(() => {
                            this.billingAddressCountryChanged();
                        })
                        .catch(() => { });

                    }
                }

            })
            .catch(() => { });

        }

        this.observerService.subscribe('pricing_tier_added|organisation_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                pricing_tiers.push(pricing_tier);
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_deleted|organisation_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers.splice(i, 1);
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tier_updated|organisation_edit_modal', (pricing_tier) => {
            if(pricing_tier) {
                let pricing_tiers = this.pricing_tiers;
                for(let i = 0; i < pricing_tiers.length; i++) {
                    if(pricing_tiers[i].id === pricing_tier["id"]) {
                        pricing_tiers[i] = pricing_tier;
                        break;
                    }
                }
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('pricing_tiers_changed|organisation_edit_modal', (pricing_tiers) => {
            if(pricing_tiers) {
                this.sortPricingTiers(pricing_tiers);
            }
        });

        this.observerService.subscribe('network_status_changed|organisation_edit_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => {} ).catch(() => { });
                }
                else {
                    this.presentAlert("Offline", "You must be online to edit an organisation, please check your network connection and try again.");
                }
            }
        });

    }

    ngOnDestroy() {
        this.observerService.destroy("pricing_tier_added|organisation_edit_modal");
        this.observerService.destroy("pricing_tier_updated|organisation_edit_modal");
		this.observerService.destroy("pricing_tier_deleted|organisation_edit_modal");
        this.observerService.destroy("pricing_tiers_changed|organisation_edit_modal");
        this.observerService.destroy("network_status_changed|organisation_edit_modal");
    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading organisation").then(() => {
                this.loadOrganisation().then(() => {
                    this.loading_spinner.message = "Loading pricing tiers";
                    this.pricingTierService.getPricingTiers().then((pricing_tiers) => {
                        if(pricing_tiers) {
                            this.sortPricingTiers(pricing_tiers);
                        }
                        this.loading_spinner.dismiss();
                        resolve();
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }

    loadOrganisation() {
        return new Promise<void>((resolve, reject) => {
            this.organisation = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getOrganisation(this.organisation_id).then((organisation: any) => {
                    if(organisation) {
                        this.organisation = organisation;
                    }
                    resolve();
                })
                .catch((error) => {
                    this.organisation = {};
                    if(error.status == 400) {
                        this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to retrieve an organisation.");
                    }
                    else if(error.status == 403) {
                        this.presentAlert("Insufficient permissions", "You don't have permission to view an organisation.");
                    }
                    else if(error.status == 404) {
                        this.presentAlert("Unavailable", "Unfortunately we're unable to retrieve an organisation at this time.");
                    }
                    else if(error.status == 0) {
                        this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadCountrySubdivisions(country_id) {
        return new Promise((resolve, reject) => {
            this.countryService.getCountrySubdivisions(country_id).then((subdivisions) => {
                resolve(subdivisions)
            })
            .catch(() => {
                reject();
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    sortPricingTiers(pricing_tiers) {
        pricing_tiers.sort((a, b) => {
            if(a['order'] < b['order']) { return -1; }
            if(a['order'] > b['order']) { return 1; }
            return 0;
        });
        this.pricing_tiers = pricing_tiers;
    }

    loadMailingAddressCountry(country_id) {
        return new Promise<void>((resolve, reject) => {
            this.mailing_address_country = null;
            this.mailing_address_subdivisions = null;
            for(let i = 0; i < this.countries.length; i++) {
                if(this.countries[i].id == country_id) {
                    this.mailing_address_country = this.countries[i];
                    this.loadCountrySubdivisions(country_id).then((subdivisions: any) => {
                        if(subdivisions) {
                            this.mailing_address_subdivisions = subdivisions;
                        }
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
                    break;
                }
            }
        });
    }

    mailingAddressCountryChanged(){

        this.mailing_address_subdivision_label = "State / Province / Region / County";
        this.mailing_address_requires_subdivision = false;
        this.mailing_address_postal_code_label = "Postcode";
        this.mailing_address_requires_postal_code = false;

        if(this.params['mailing_address_country_id']) {

            if(this.mailing_address_country.subdivision_name) {
                this.mailing_address_subdivision_label = this.mailing_address_country.subdivision_name;
            }

            if(this.mailing_address_subdivisions && this.mailing_address_subdivisions.length != 0) {
                this.mailing_address_requires_subdivision = true;
            }

            if(this.mailing_address_country.postal_code_name) {
                this.mailing_address_postal_code_label = this.mailing_address_country.postal_code_name;
            }

            if(this.mailing_address_country.postal_code_required == true) {
                this.mailing_address_requires_postal_code = true;
            }

        }

        // NOTE: mailing_address_subdivision_label_changed is used to force UI to render correctly
        this.mailing_address_subdivision_label_changed = false;

        setTimeout(() => {
            this.mailing_address_subdivision_label_changed = true;
        }, 0);

    }

    loadBillingAddressCountry(country_id) {
        const promise = new Promise<void>((resolve, reject) => {
            this.billing_address_country = null;
            this.billing_address_subdivisions = null;
            for(let i = 0; i < this.countries.length; i++) {
                if(this.countries[i].id == country_id) {
                    this.billing_address_country = this.countries[i];
                    this.loadCountrySubdivisions(country_id).then((subdivisions: any) => {
                        if(subdivisions) {
                            this.billing_address_subdivisions = subdivisions;
                        }
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
                    break;
                }
            }
        });
        return promise;
    }

    billingAddressCountryChanged(){

        this.billing_address_subdivision_label = "State / Province / Region / County";
        this.billing_address_requires_subdivision = false;
        this.billing_address_postal_code_label = "Postcode";
        this.billing_address_requires_postal_code = false;

        if(this.params['billing_address_country_id']) {

            if(this.billing_address_country.subdivision_name) {
                this.billing_address_subdivision_label = this.billing_address_country.subdivision_name;
            }

            if(this.billing_address_subdivisions && this.billing_address_subdivisions.length != 0) {
                this.billing_address_requires_subdivision = true;
            }

            if(this.billing_address_country.postal_code_name) {
                this.billing_address_postal_code_label = this.billing_address_country.postal_code_name;
            }

            if(this.billing_address_country.postal_code_required == true) {
                this.billing_address_requires_postal_code = true;
            }

        }

        // NOTE: billing_address_subdivision_label_changed is used to force UI to render correctly
        this.billing_address_subdivision_label_changed = false;

        setTimeout(() => {
            this.billing_address_subdivision_label_changed = true;
        }, 0);

    }

    update() {

        let validated = true;

        if(this.params['title'] == null || this.params['title'].trim() === "") {
            this.presentAlert("Title required", "Please enter a title");
            validated = false;
        }

        if(validated) {
            this.updateOrganisation().then(() => {
                this.modalController.dismiss();
            });
        }

    }

    updateOrganisation() {
        return new Promise<void>((resolve, reject) => {
            this.presentSpinner("Updating organisation").then(() => {
                this.authService.isLoggedIn().then(() => {
                    this.apiService.updateOrganisation(this.organisation_id, this.params).then((organisation) => {
                        if(organisation) {
                            this.organisationService.updateOrganisation(this.organisation).then(() => {
                                this.cartService.get().then((cart) => {
                                    if(cart['organisation']) {
                                        if(cart['organisation'].id == this.organisation.id) {
                                            this.cartService.updateOrganisation(this.organisation['id']).then(() => {}).catch(() => {});
                                        }
                                    }
                                })
                                .catch(() => { });
                            })
                            .catch(() => { });
                        }
                        this.spinner.dismiss();
                        resolve();
                    })
                    .catch((error) => {
                        if(error) {
                            if(error.status === 400) {
                                this.presentAlert("Unknown error", "Unfortunately something went wrong when trying to update this organisation.");
                            }
                            else if(error.status === 403) {
                                this.presentAlert("Insufficient permissions", "You don't have permission to update this organisation.");
                            }
                            else if(error.status == 404) {
                                this.presentAlert("Unavailable", "Unfortunately we're unable to update this organisation at this time.");
                            }
                            else if(error.status == 0) {
                                this.presentAlert("Connection failure", "Unable to reach the server. Please try again.");
                            }
                        }
                        this.spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.router.navigate(["switch-account"], { replaceUrl: true }).then(() => {
                        window.location.reload();
                    });
                });
            });
        });
    }

    async presentMailingAddressCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            let existing_mailing_address_country_id = "";
            if(this.params['mailing_address_country_id']) {
                existing_mailing_address_country_id = this.params['mailing_address_country_id'];
            }
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['mailing_address_country_id'] ? this.params['mailing_address_country_id'] : "")
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data === "country_deleted") {
                        this.params["mailing_address_country_id"] = "";
                        this.mailing_address_country = null;
                        this.mailingAddressCountryChanged();
                    } 
                    else {
                        if(data.data['country_id'] != existing_mailing_address_country_id) {
                            this.params["mailing_address_country_id"] = data.data['country_id'];
                            this.loadMailingAddressCountry(data.data['country_id']).then(() => {
                                this.mailingAddressCountryChanged();
                            })
                            .catch(() => { });
                        }
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentBillingAddressCountryPickerModal() {
        if(!this.country_picker_modal_open) {
            this.country_picker_modal_open = true;
            let existing_billing_address_country_id = "";
            if(this.params['billing_address_country_id']) {
                existing_billing_address_country_id = this.params['billing_address_country_id'];
            }
            const modal = await this.modalController.create({
                component: CountryPickerPage,
                cssClass: this.modal_css_class,
                componentProps: {
                    country_id: (this.params['billing_address_country_id'] ? this.params['billing_address_country_id'] : "")
                }
            });
            modal.onDidDismiss().then((data) => {
                this.country_picker_modal_open = false;
                if(data.data) {
                    if(data.data === "country_deleted") {
                        this.params["billing_address_country_id"] = "";
                        this.billing_address_country = null;
                        this.billingAddressCountryChanged();
                    } 
                    else {
                        if(data.data['country_id'] != existing_billing_address_country_id) {
                            this.params["billing_address_country_id"] = data.data['country_id'];
                            this.loadBillingAddressCountry(data.data['country_id']).then(() => {
                                this.billingAddressCountryChanged();
                            })
                            .catch(() => { });
                        }
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, message) {
        const alert = await this.alertController.create({
            header: header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

}